export default "__VITE_ASSET__b7fee6f7__"